
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface PropertyStatusProps {
  status: string;
  setStatus: (value: string) => void;
}

export const PropertyStatusSection = ({
  status,
  setStatus
}: PropertyStatusProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="status">Listing Status*</Label>
      <Select 
        required
        value={status}
        onValueChange={setStatus}
      >
        <SelectTrigger id="status" className="bg-muted">
          <SelectValue placeholder="Select status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="pending">Pending</SelectItem>
          <SelectItem value="sold">Sold</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
